export const GroupConst = {
  MAX_NAME_LENGTH: 80,
};

export type Group = {
  id?: string;
  name: string;
  email: string;
  isIgnoreAclSetting: boolean;
};

export type GroupMetaData = {
  id?: string;
  orgId: string;
  name: string;
};

export type GroupRole = "GroupManager" | "Staff";

export function validateGroupName(name: string) {
  if (name.length > GroupConst.MAX_NAME_LENGTH) {
    return `${GroupConst.MAX_NAME_LENGTH}文字まで入力できます`;
  }
  return;
}

export type GroupMap = { [key: string]: Group };

/*
  Group の ID をキーに、Group を値に持つオブジェクトを作成する
  @param groups Group[]
  @returns { [key: string]: Group }
*/
export const buildGroupMap = (groups: Group[]): GroupMap => {
  return groups.reduce((groupMap: { [key: string]: Group }, g: Group) => {
    groupMap[g.id!] = g;
    return groupMap;
  }, {});
};
